import { useState } from 'react';
import { Link } from 'react-router-dom';
import { GROCERY_STAPLES } from '../utils/nearbyPlaces';
import {
  formatPriceInput,
  getStoreKey,
  upsertGroceryStaples,
} from '../utils/groceryStaples';

const GroceryStapleForm = ({ item, auth, onSaved, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(() =>
    Object.fromEntries(
      GROCERY_STAPLES.map(({ key }) => [key, formatPriceInput(item[key])])
    )
  );
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  if (!auth?.accessToken) {
    return (
      <p className="map-staple-form-signin">
        <Link to="/login" state={{ from: { pathname: '/map', search: '?view=grocery' } }}>
          Sign in
        </Link>
        {' '}to share prices you see in-store.
      </p>
    );
  }

  const handleChange = (key, value) => {
    setValues((prev) => ({ ...prev, [key]: value.replace(/[^0-9.]/g, '') }));
    setStatus('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setSaving(true);
    setStatus('');

    try {
      const response = await upsertGroceryStaples({
        storeKey: getStoreKey(item),
        storeName: item.name,
        address: item.address || '',
        ...values,
      }, auth.accessToken);

      onSaved?.(response.data);
      setStatus('Saved — thanks for helping the community!');
      setOpen(false);
    } catch (err) {
      setStatus(err?.response?.data?.message || 'Could not save prices. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`map-staple-form${compact ? ' map-staple-form--compact' : ''}`}>
      <button
        type="button"
        className="map-staple-form-toggle"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        {open ? 'Hide price form' : 'Share prices from this store'}
      </button>

      {open && (
        <form className="map-staple-form-fields" onSubmit={handleSubmit}>
          {GROCERY_STAPLES.map(({ key, emoji, label }) => (
            <label key={key} className="map-staple-form-field">
              <span>{emoji} {label}</span>
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                value={values[key]}
                onChange={(event) => handleChange(key, event.target.value)}
                onClick={(event) => event.stopPropagation()}
              />
            </label>
          ))}
          <button
            type="submit"
            className="map-staple-form-submit"
            disabled={saving}
            onClick={(event) => event.stopPropagation()}
          >
            {saving ? 'Saving…' : 'Save prices'}
          </button>
        </form>
      )}

      {status && (
        <p className={`map-staple-form-status${status.startsWith('Saved') ? ' success' : ' error'}`}>
          {status}
        </p>
      )}
    </div>
  );
};

export default GroceryStapleForm;